import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import FormInput from '../../common/form/Input';
import FormPhoneInput from '../../common/form/PhoneInput';
import FormMultiSelect from '../../common/form/MultiSelect';
import FormSelectLabeled from '../../common/form/SelectLabeled';
import LoadingOverlay from '../../common/LoadingOverlay';
import Form from '../../common/form/Form';
import { Roles } from '../../../utilities/Enums';
import { Property } from '../../../api/Property';
import {
    UserUpdate,
    getUser,
    createUser,
    updateUser,
    deleteUser,
    resendRegistration
} from '../../../api/User';
import { getCompanyProperties } from '../../../api/Company';
import { Role } from '../../../api/Role';
import { formatPhoneNumber } from '../../../utilities/Utils';
import CheckboxLabeled from '../../common/form/CheckboxLabeled';
import { FormText } from 'reactstrap';
import Toggle from '../../common/form/Toggle';
import '../../../styles/AdminPermissions.css'; 											   
import { OptionValues } from 'react-select';
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../utilities/identity';

interface State {
    wasFormValidated: boolean;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
    emailRegistered: boolean;
    phone: string;
    companyId: number | null;
    errorMessage?: string;
    successMessage?: string;
    mappedProperties: number[];
    companyProperties: Property[];
    roleId: string;
    isLoading: boolean;
    contextAvailableRoles: { value: string; label: string }[];
    receiveTourSignupEmails: boolean;
    //permissions: any[];
     // New state properties for toggles
     PropertyAnalyticsPermission: boolean;
     PropertyManagePermission: boolean;
     PropertyDashboardPermission: boolean;
     CompanyAnalyticsPermission: boolean;
     CompanyManagePermission: boolean;
     CompanyDashboardPermission: boolean;
     SystemAnalyticsPermission: boolean;
     SystemManagePermission: boolean;
     SystemDashboardPermission: boolean;
     analyticsRole: string;  
     manageRole: string;     
     dashboardRole: string;
     showAddPropertyModal: boolean;
}

interface Props extends RouteComponentProps<{}> {
    userId?: number;
    currentUserAvailableRoles: Role[];
    propertyCreatedFrom?: number;
    companyCreatedFrom?: number;
    updateTreeview: () => void;
    updateUserId: (newUserId: number) => void;
    //onResendRegistrationEmail: () => void;
    onUserDelete: () => void;
}

class EditUserPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            wasFormValidated: false,
            firstName: '',
            lastName: '',
            email: '',
            username: '',
            emailRegistered: false,
            phone: '',
            companyId: props.companyCreatedFrom || 0,
            mappedProperties: props.propertyCreatedFrom ? [props.propertyCreatedFrom] : [],
            companyProperties: [],
            roleId: '',
            isLoading: false,
            contextAvailableRoles: this.props.currentUserAvailableRoles.map(role => ({
                value: role.id.toString(),
                label: role.name
            })),
            receiveTourSignupEmails: false,
            //permissions: [],
            PropertyAnalyticsPermission: false,  
            PropertyManagePermission: false,     
            PropertyDashboardPermission: false,
            CompanyAnalyticsPermission: false,
            CompanyManagePermission: false,
            CompanyDashboardPermission: false,
            SystemAnalyticsPermission: false,
            SystemManagePermission: false,
            SystemDashboardPermission: false,
            analyticsRole: '',  
            manageRole: '',     
            dashboardRole: '', 
            showAddPropertyModal: false,
        };
        
        this.getState = this.getState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.multiSelectChangeHandler = this.multiSelectChangeHandler.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.handleUserDeleteClick = this.handleUserDeleteClick.bind(this);
        this.needsPropertyAssociated = this.needsPropertyAssociated.bind(this);
        this.updateContextAvailableRoles = this.updateContextAvailableRoles.bind(this);
        this.handleResendRegistrationEmailClick = this.handleResendRegistrationEmailClick.bind(
            this
        );
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.isPropertyRole = this.isPropertyRole.bind(this);
        this.isCompanyRole = this.isCompanyRole.bind(this);
        this.isSystemRole = this.isSystemRole.bind(this);
    }

    isPropertyRole(roleId: Roles): boolean {
        const propertyRoles: Roles[] = [
            Roles.PropertyUserId,
            Roles.PropertyDashboardUserId,
            Roles.PropertyDashboardAdminId,
            Roles.PropertyAnalyticsUserId,
            Roles.PropertyManageUserId,
            Roles.PropertyManageAdminId,
            Roles.PropertyAdminId,
        ];
        return propertyRoles.includes(roleId);
    }

    isCompanyRole(roleId: Roles): boolean {
        const companyRoles: Roles[] = [
            Roles.CompanyDashboardUserId,
            Roles.CompanyDashboardAdminId,
            Roles.CompanyAnalyticsUserId,
            Roles.CompanyManageUserId,
            Roles.CompanyManageAdminId,
            Roles.CompanyAdminId,
        ];
        return companyRoles.includes(roleId);
    }

    isSystemRole(roleId: Roles): boolean {
        const systemRoles: Roles[] = [
            Roles.SystemDashboardUserId,
            Roles.SystemDashboardAdminId,
            Roles.SystemAnalyticsUserId,
            Roles.SystemAnalyticsAdminId,
            Roles.SystemManageUserId,
            Roles.SystemManageAdminId,
            Roles.SystemAdminId,
        ];
        return systemRoles.includes(roleId);
    }
        
    componentDidMount() {
        this.getState();
    }

    handleToggleChange = (permissionType: string, checked: boolean) => {
        const roleKey = `${permissionType.replace('Permission', 'Role')}` as keyof State;  
        this.setState({
            [permissionType]: checked,
            [roleKey]: checked ? this.state[roleKey] : '',
        } as Pick<State, keyof State>);
    };

     private mapPermissionRoleToRoleId(permissionType: string, role: string): string {
         switch (permissionType) {
             case 'PropertyAnalyticsPermission':
                 return role === 'admin' ? Number(Roles.PropertyAnalyticsUserId).toString() : Number(Roles.PropertyAnalyticsUserId).toString();  
             case 'PropertyManagePermission':
                 return role === 'admin' ? Number(Roles.PropertyManageAdminId).toString() : Number(Roles.PropertyManageUserId).toString();
             case 'PropertyDashboardPermission':
                 return role === 'admin' ? Number(Roles.PropertyDashboardAdminId).toString() : Number(Roles.PropertyDashboardUserId).toString();
             case 'CompanyAnalyticsPermission':
                 return role === 'admin' ? Number(Roles.CompanyAnalyticsUserId).toString() : Number(Roles.CompanyAnalyticsUserId).toString();  
             case 'CompanyManagePermission':
                 return role === 'admin' ? Number(Roles.CompanyManageAdminId).toString() : Number(Roles.CompanyManageUserId).toString();
             case 'CompanyDashboardPermission':
                 return role === 'admin' ? Number(Roles.CompanyDashboardAdminId).toString() : Number(Roles.CompanyDashboardUserId).toString();              
            case 'SystemAnalyticsPermission':
                 return role === 'admin' ? Number(Roles.SystemAnalyticsAdminId).toString() : Number(Roles.SystemAnalyticsUserId).toString();  
            case 'SystemManagePermission':
                 return role === 'admin' ? Number(Roles.SystemManageAdminId).toString() : Number(Roles.SystemManageUserId).toString();
            case 'SystemDashboardPermission':
                 return role === 'admin' ? Number(Roles.SystemDashboardAdminId).toString() : Number(Roles.SystemDashboardUserId).toString();                    
            default:
                 return '';
         }
	 
         console.log("Which Role: ", role);
     }
	 
     private preparePermissions(): number[] {
         const permissions: number[] = [];
     
         if (this.state.PropertyAnalyticsPermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('PropertyAnalyticsPermission', this.state.analyticsRole)!));
         }
         if (this.state.PropertyManagePermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('PropertyManagePermission', this.state.manageRole)!));
         }
         if (this.state.PropertyDashboardPermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('PropertyDashboardPermission', this.state.dashboardRole)!));
         }
	 
         if (this.state.CompanyAnalyticsPermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('CompanyAnalyticsPermission', this.state.analyticsRole)!));
         }
         if (this.state.CompanyManagePermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('CompanyManagePermission', this.state.manageRole)!));
         }
         if (this.state.CompanyDashboardPermission) {
             permissions.push(Number(this.mapPermissionRoleToRoleId('CompanyDashboardPermission', this.state.dashboardRole)!));
         }

         if (this.state.SystemAnalyticsPermission) {
            permissions.push(Number(this.mapPermissionRoleToRoleId('SystemAnalyticsPermission', this.state.analyticsRole)!));
        }
        if (this.state.SystemManagePermission) {
            permissions.push(Number(this.mapPermissionRoleToRoleId('SystemManagePermission', this.state.manageRole)!));
        }
        if (this.state.SystemDashboardPermission) {
            permissions.push(Number(this.mapPermissionRoleToRoleId('SystemDashboardPermission', this.state.dashboardRole)!));
        }
    
        return permissions;
        console.log("Which Permission: ", permissions);
    }   

    
    
    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.userId !== this.props.userId) {
            this.getState();
        }
    }

    render() {
        const isUser = (userIsCompanyManageUser() || userIsPropertyManageUser() || userIsSystemManageUser());
        let deleteButton = this.props.userId && (
            <button
                type="button"
                className="btn btn-danger font-weight-bold mb-4"
                onClick={() => this.handleUserDeleteClick(this.props.userId!)}
                disabled={isUser}
            >
                Delete User
            </button>
        );

        let resendRegistrationButton = this.props.userId && !this.state.emailRegistered && (
            <button
                type="button"
                className="btn font-weight-bold mb-4"
                onClick={() => this.handleResendRegistrationEmailClick(this.props.userId!)}
                disabled={isUser}
            >
                Resend Registration Email
            </button>
        );

        let renderAdditionalButtons = (
            <div>
                {resendRegistrationButton}
                {deleteButton}
            </div>
        );

        return (
            <div>
                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={true} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <Form
                                wasFormValidated={this.state.wasFormValidated}
                                inBootstrapColumn={true}
                                disabled={isUser}
                                submitButtonText={
                                    this.props.userId ? 'Update User Information' : 'Create User'
                                }
                                errorMessage={this.state.errorMessage}
                                successMessage={this.state.successMessage}
                                onSubmit={this.onSubmit}
                                onFormValidated={() =>
                                    this.inputChangeHandler('wasFormValidated', true)
                                }
                                additionalButtons={renderAdditionalButtons}
                            >
                                <div className="card info-card">
                                    <div className="card-body">
                                        <div className="form-row">
                                            <FormInput
                                                inputProps={{
                                                    id: 'first-name',
                                                    name: 'firstName',
                                                    value: this.state.firstName,
                                                    required: true,
                                                    disabled: isUser,
                                                }}
                                                labelProps={{
                                                    labelText: 'First Name',
                                                    invalidText:
                                                        "Please enter the user's first name"
                                                }}
                                                onChange={this.inputChangeHandler}
                                                
                                                controlCssClass="col-12 col-md-6"
                                            />
                                            <FormInput
                                                inputProps={{
                                                    id: 'last-name',
                                                    name: 'lastName',
                                                    value: this.state.lastName,
                                                    required: true,
                                                    disabled: isUser,
                                                }}
                                                labelProps={{
                                                    labelText: 'Last Name',
                                                    invalidText: "Please enter the user's last name"
                                                }}
                                                onChange={this.inputChangeHandler}
                                                controlCssClass="col-12 col-md-6"
                                            />
                                        </div>
                                        <FormPhoneInput
                                            inputProps={{
                                                id: 'phone',
                                                name: 'phone',
                                                value: this.state.phone,
                                                required: true,
                                                disabled: isUser,
                                            }}
                                            labelProps={{
                                                labelText: 'Phone'
                                            }}
                                            onChange={this.inputChangeHandler}
                                        />
                                        <FormInput
                                            inputProps={{
                                                id: 'email',
                                                name: 'email',
                                                value: this.state.email,
                                                required: true,
                                                type: 'email',
                                                disabled: isUser,
                                            }}
                                            labelProps={{
                                                labelText: 'Email',
                                                invalidText: 'Please enter a valid email address'
                                            }}
                                            onChange={this.inputChangeHandler}
                                        />
                                        <FormInput
                                            inputProps={{
                                                id: 'username',
                                                name: 'username',
                                                value: this.state.username,
                                                required: true,
                                                type: 'username',
                                                disabled: isUser,
                                            }}
                                            labelProps={{
                                                labelText: 'Username'
                                            }}
                                            onChange={this.inputChangeHandler}
                                        />
                                        {this.state.contextAvailableRoles.length > 0 && (
                                            <FormSelectLabeled
                                                selectProps={{
                                                    id: 'role-id',
                                                    name: 'roleId',
                                                    required: true,
                                                    value: String(this.state.roleId),
                                                    disabled:
                                                        this.state.contextAvailableRoles.length ===
                                                        1 || isUser
                                                }}
                                                labelProps={{
                                                    labelText: 'Role',
                                                    invalidText: 'Please select a valid role'
                                                }}
                                                selectOptions={this.state.contextAvailableRoles}
                                                //onChange={this.inputChangeHandler}
                                                //onChange={(inputName, newValue) => this.handleRoleChange(inputName, newValue)}
                                                onChange={(inputName: string, newValue: OptionValues | undefined) => this.handleRoleChange(inputName, newValue)} // Correct type

                                            />
                                        )}

                                        {this.needsPropertyAssociated(
                                            parseInt(this.state.roleId, 10)
                                        ) && (
                                                <FormMultiSelect
                                                    label={'Associated Properties'}
                                                    options={this.state.companyProperties.map(
                                                        property => ({
                                                            label: property.name,
                                                            value: property.id
                                                        })
                                                    )}
                                                    initialSelectedOptions={this.state.mappedProperties}
                                                    onChange={this.multiSelectChangeHandler}
                                                    disabled={isUser}
                                                />
                                                )}
                                              {this.needsPropertyAdminAssociated(parseInt(this.state.roleId, 10)) && (
    <>
        <FormText className="permissions-title">PERMISSIONS</FormText>
        <div className="permissions-container">
            {/* Analytics */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Analytics</span>
                    <Toggle
                        checked={this.state.PropertyAnalyticsPermission}
                        disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}  
                        onChange={(checked) => this.handleToggleChange('PropertyAnalyticsPermission', checked)}
                    />
                </div>
                {this.state.PropertyAnalyticsPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="analyticsRole"
                                value="user"
                                checked={this.state.analyticsRole === 'user' || (this.state.analyticsRole === '' && this.state.PropertyAnalyticsPermission)}
                                onChange={() => this.setState({ analyticsRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Manage */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Manage</span>
                    <Toggle
                        checked={this.state.PropertyManagePermission}
                        disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}  
                        onChange={(checked) => this.handleToggleChange('PropertyManagePermission', checked)}
                    />
                </div>
                {this.state.PropertyManagePermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="admin"
                                checked={this.state.manageRole === 'admin' || (this.state.manageRole === '' && this.state.PropertyManagePermission)}
                                onChange={() => this.setState({ manageRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="user"
                                checked={this.state.manageRole === 'user'}
                                onChange={() => this.setState({ manageRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Dashboard */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Dashboard</span>
                    <Toggle
                        checked={this.state.PropertyDashboardPermission}
                        disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}  
                        onChange={(checked) => this.handleToggleChange('PropertyDashboardPermission', checked)}
                    />
                </div>
                {this.state.PropertyDashboardPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="admin"
                                checked={this.state.dashboardRole === 'admin' || (this.state.dashboardRole === '' && this.state.PropertyDashboardPermission)}
                                onChange={() => this.setState({ dashboardRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="user"
                                checked={this.state.dashboardRole === 'user'}
                                onChange={() => this.setState({ dashboardRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.PropertyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>
        </div>
    </>
)}

{this.needsCompanyAssociated(parseInt(this.state.roleId, 10)) && (
    <>
        <FormText className="permissions-title">PERMISSIONS</FormText>
        <div className="permissions-container">
            {/* Analytics */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Analytics</span>
                    <Toggle
                        checked={this.state.CompanyAnalyticsPermission}
						disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser} 																		  
                        onChange={(checked) => this.handleToggleChange('CompanyAnalyticsPermission', checked)}
                    />
                </div>
                {this.state.CompanyAnalyticsPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="analyticsRole"
                                value="user"
                                checked={this.state.analyticsRole === 'user' || (this.state.analyticsRole === '' && this.state.CompanyAnalyticsPermission)}
                                onChange={() => this.setState({ analyticsRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Manage */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Manage</span>
                    <Toggle
                        checked={this.state.CompanyManagePermission}
						disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}																		  
                        onChange={(checked) => this.handleToggleChange('CompanyManagePermission', checked)}
                    />
                </div>
                {this.state.CompanyManagePermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="admin"
                                checked={this.state.manageRole === 'admin' || (this.state.manageRole === '' && this.state.CompanyManagePermission)}
                                onChange={() => this.setState({ manageRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="user"
                                checked={this.state.manageRole === 'user'}
                                onChange={() => this.setState({ manageRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Dashboard */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Dashboard</span>
                    <Toggle
                        checked={this.state.CompanyDashboardPermission}
						disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser} 																		  
                        onChange={(checked) => this.handleToggleChange('CompanyDashboardPermission', checked)}
                    />
                </div>
                {this.state.CompanyDashboardPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="admin"
                                checked={this.state.dashboardRole === 'admin' || (this.state.dashboardRole === '' && this.state.CompanyDashboardPermission)}
                                onChange={() => this.setState({ dashboardRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="user"
                                checked={this.state.dashboardRole === 'user'}
                                onChange={() => this.setState({ dashboardRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.CompanyAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>
        </div>
    </>
)}


{this.needsSystemAssociated(parseInt(this.state.roleId, 10)) && (
    <>
        <FormText className="permissions-title">PERMISSIONS</FormText>
        <div className="permissions-container">
            {/* Analytics */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Analytics</span>
                    <Toggle
                        checked={this.state.SystemAnalyticsPermission}
						disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser} 																		  
                        onChange={(checked) => this.handleToggleChange('SystemAnalyticsPermission', checked)}
                    />
                </div>
                {this.state.SystemAnalyticsPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="analyticsRole"
                                value="user"
                                checked={this.state.analyticsRole === 'admin' || (this.state.analyticsRole === '' && this.state.SystemAnalyticsPermission)}
                                onChange={() => this.setState({ analyticsRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="analyticsRole"
                                value="user"
                                checked={this.state.analyticsRole === 'user'}
                                onChange={() => this.setState({ analyticsRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Manage */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Manage</span>
                    <Toggle
                        checked={this.state.SystemManagePermission}
						disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser} 																		  
                        onChange={(checked) => this.handleToggleChange('SystemManagePermission', checked)}
                    />
                </div>
                {this.state.SystemManagePermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="admin"
                                checked={this.state.manageRole === 'admin' || (this.state.manageRole === '' && this.state.SystemManagePermission)}
                                onChange={() => this.setState({ manageRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="manageRole"
                                value="user"
                                checked={this.state.manageRole === 'user'}
                                onChange={() => this.setState({ manageRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>

            {/* Dashboard */}
            <div className="permission-box">
                <div className="permission-header">
                    <span className="permission-label">Dashboard</span>
                    <Toggle
                        checked={this.state.SystemDashboardPermission}
						disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser} 																		  
                        onChange={(checked) => this.handleToggleChange('SystemDashboardPermission', checked)}
                    />
                </div>
                {this.state.SystemDashboardPermission && (
                    <div className="role-options">
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="admin"
                                checked={this.state.dashboardRole === 'admin' || (this.state.dashboardRole === '' && this.state.SystemDashboardPermission)}
                                onChange={() => this.setState({ dashboardRole: 'admin' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            Admin
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="dashboardRole"
                                value="user"
                                checked={this.state.dashboardRole === 'user'}
                                onChange={() => this.setState({ dashboardRole: 'user' })}
                                disabled={this.state.roleId !== String(Roles.SystemAdminId) || isUser}
                            />
                            User
                        </label>
                    </div>
                )}
            </div>
        </div>
    </>
)}


                                        <CheckboxLabeled
                                            labelProps={{
                                                labelText: 'Receive Tour Signup Emails?'
                                            }}
                                            inputProps={{
                                                id: 'receive-tour-signup-emails',
                                                name: 'receiveTourSignupEmails',
                                                checked: this.state.receiveTourSignupEmails,
                                                disabled: isUser
                                            }}
                                            onChange={() =>
                                                this.setState({
                                                    ...this.state,
                                                    receiveTourSignupEmails: !this.state
                                                        .receiveTourSignupEmails
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    async getState() {
        this.setState({
            ...this.state,
            isLoading: true,
            wasFormValidated: false,
            errorMessage: undefined,
            successMessage: undefined
        });

        if (!this.props.userId) {
            // blank userId indicates user is being created
            // get properties of company created from
            if (this.props.companyCreatedFrom) {
                this.updateContextAvailableRoles();
                let propertiesResult = await getCompanyProperties(this.props.companyCreatedFrom);
                if (propertiesResult.success && propertiesResult.data) {
                    this.setState({
                        companyProperties: propertiesResult.data,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        errorMessage: propertiesResult.error!,
                        isLoading: false
                    });
                }
            }
            return;
        }
        let userResult = await getUser(this.props.userId);

        if (userResult.success && userResult.data) {
            let properties: Property[] = [];
            if (userResult.data.companyId) {
                let propertiesResult = await getCompanyProperties(userResult.data.companyId);
                if (!(propertiesResult.success && propertiesResult.data)) {
                    this.setState({
                        errorMessage: propertiesResult.error!,
                        isLoading: false
                    });
                    return;
                }
                properties = propertiesResult.data;
            }

            this.setState({
                firstName: userResult.data.firstName,
                lastName: userResult.data.lastName,
                phone: formatPhoneNumber(userResult.data.phone),
                email: userResult.data.email,
                username: userResult.data.username,
                emailRegistered: userResult.data.emailConfirmed,
                companyId: userResult.data.companyId,
                mappedProperties: userResult.data.propertyIds,
                roleId: userResult.data.role.toString(),
                companyProperties: properties,
                isLoading: false,
                receiveTourSignupEmails: userResult.data.receiveTourSignupEmails,
                PropertyAnalyticsPermission: userResult.data.permissions.includes(Number(Roles.PropertyAnalyticsUserId)),
                PropertyManagePermission: userResult.data.permissions.includes(Number(Roles.PropertyManageUserId)) || userResult.data.permissions.includes(Number(Roles.PropertyManageAdminId)),
                PropertyDashboardPermission: userResult.data.permissions.includes(Number(Roles.PropertyDashboardUserId)) || userResult.data.permissions.includes(Number(Roles.PropertyDashboardAdminId)),

                 // Company Permissions
                CompanyAnalyticsPermission: userResult.data.permissions.includes(Number(Roles.CompanyAnalyticsUserId)),
                CompanyManagePermission:
                    userResult.data.permissions.includes(Number(Roles.CompanyManageUserId)) ||
                    userResult.data.permissions.includes(Number(Roles.CompanyManageAdminId)),
                CompanyDashboardPermission:
                    userResult.data.permissions.includes(Number(Roles.CompanyDashboardUserId)) ||
                    userResult.data.permissions.includes(Number(Roles.CompanyDashboardAdminId)),

                // System Permissions
                SystemAnalyticsPermission: 
                    userResult.data.permissions.includes(Number(Roles.SystemAnalyticsUserId)) || 
                    userResult.data.permissions.includes(Number(Roles.SystemAnalyticsAdminId)),
                SystemManagePermission:
                    userResult.data.permissions.includes(Number(Roles.SystemManageUserId)) ||
                    userResult.data.permissions.includes(Number(Roles.SystemManageAdminId)),
                SystemDashboardPermission:
                    userResult.data.permissions.includes(Number(Roles.SystemDashboardUserId)) ||
                    userResult.data.permissions.includes(Number(Roles.SystemDashboardAdminId)),

                analyticsRole: (userResult.data.permissions.includes(Number(Roles.SystemAnalyticsAdminId)))
                ? 'admin'  
                : userResult.data.permissions.includes(Number(Roles.PropertyAnalyticsUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.CompanyAnalyticsUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.SystemAnalyticsUserId))
                   ? 'user' : '',
                manageRole: (userResult.data.permissions.includes(Number(Roles.PropertyManageAdminId)) ||
                userResult.data.permissions.includes(Number(Roles.CompanyManageAdminId)) ||
                userResult.data.permissions.includes(Number(Roles.SystemManageAdminId)))
                ? 'admin'  
                : (userResult.data.permissions.includes(Number(Roles.PropertyManageUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.CompanyManageUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.SystemManageUserId)))
                ? 'user' 
                : '',
                dashboardRole: (userResult.data.permissions.includes(Number(Roles.PropertyDashboardAdminId)) ||
                userResult.data.permissions.includes(Number(Roles.CompanyDashboardAdminId)) ||
                userResult.data.permissions.includes(Number(Roles.SystemDashboardAdminId)))
                ? 'admin'  
                : (userResult.data.permissions.includes(Number(Roles.PropertyDashboardUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.CompanyDashboardUserId)) ||
                   userResult.data.permissions.includes(Number(Roles.SystemDashboardUserId)))
                ? 'user' 
                : ''

            });
            this.updateContextAvailableRoles();
        } else {
            this.setState({
                errorMessage: userResult.error!,
                isLoading: false
            });
        }
    }

    handleRoleChange(inputName: string, newValue?: OptionValues) {
        if (newValue === undefined || typeof newValue === 'boolean') {
            return; 
        }

        const roleId = String(newValue);
    
        this.setState({ roleId }, () => {
            // Default state reset for all roles
            let defaultPermissions = {
                PropertyAnalyticsPermission: false,
                PropertyManagePermission: false,
                PropertyDashboardPermission: false,
                analyticsRole: 'user',
                manageRole: 'admin',
                dashboardRole: 'admin',
            };
    
            // Handle permissions based on the selected roleId
            if (roleId === String(Roles.PropertyAdminId)) {
                // PropertyAdmin has all permissions
                this.setState({
                    ...defaultPermissions, // Reset to default permissions
                    PropertyAnalyticsPermission: true,
                    PropertyManagePermission: true,
                    PropertyDashboardPermission: true,
                    analyticsRole: 'user',
                    manageRole: 'admin',
                    dashboardRole: 'admin',
                });
            } else if (roleId === String(Roles.CompanyAdminId)) {
                // CompanyAdmin has different permissions
                this.setState({
                    ...defaultPermissions, // Reset to default permissions
                    CompanyAnalyticsPermission: true,
                    CompanyManagePermission: true,
                    CompanyDashboardPermission: true,
                    analyticsRole: 'user',
                    manageRole: 'admin',
                    dashboardRole: 'admin',
                });
            } else if (roleId === String(Roles.SystemAdminId)) {
                // SystemAdmin has different permissions
                this.setState({
                    ...defaultPermissions, // Reset to default permissions
                    SystemAnalyticsPermission: true,
                    SystemManagePermission: true,
                    SystemDashboardPermission: true,
                    analyticsRole: 'user',
                    manageRole: 'admin',
                    dashboardRole: 'admin',
                });
            }else {
                // Reset permissions for other roles (no permissions granted)
                this.setState(defaultPermissions); // Reset to default permissions
            }
        });
    }    
    
    private async onSubmit() {
        this.setState({
            isLoading: true
        });

        let systemAdmin = this.state.contextAvailableRoles.find(
            element => element.value === Roles.SystemAdminId
        );

        let roleId = parseInt(this.state.roleId, 10);
        const permissions = this.preparePermissions();

        let user: UserUpdate = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            username: this.state.username,
            phone: this.state.phone,
            companyId:
                systemAdmin && systemAdmin.value === this.state.roleId
                    ? null
                    : this.state.companyId,
            propertyIds: this.needsPropertyAssociated(roleId) ? this.state.mappedProperties : [],
            role: roleId,
            receiveTourSignupEmails: this.state.receiveTourSignupEmails,
            permissions,
        };

        let result = this.props.userId
            ? await updateUser(this.props.userId, user)
            : await createUser(user);

        if (result.success) {
            this.setState({
                ...this.state,
                successMessage: 'Data submitted successfully',
                isLoading: false
            });
            this.props.updateTreeview();
            if (!this.props.userId && result.data) {
                this.props.updateUserId(result.data.id);
            }
        } else {
            this.setState({
                ...this.state,
                errorMessage: result.error!,
                isLoading: false
            });
        }
    }

    private inputChangeHandler(inputName: string, newValue: string | boolean | number) {
        this.setState({
            ...this.state,
            errorMessage: undefined,
            successMessage: undefined,
            [inputName]: newValue
        });
    }

    private multiSelectChangeHandler(newValues: number[]) {
        this.setState({
            ...this.state,
            mappedProperties: newValues
        });
    }

    private async handleUserDeleteClick(userId: number) {
        if (confirm('This will permanently delete this user.')) {
            this.setState({
                isLoading: true
            });
            var deleteResult = await deleteUser(userId);
            if (deleteResult.success) {
                this.props.onUserDelete();
            } else if (deleteResult.error) {
                this.setState({
                    successMessage: undefined,
                    errorMessage: deleteResult.error,
                    isLoading: false
                });
            }
        }
    }

    private async handleResendRegistrationEmailClick(userId: number) {
        this.setState({
            isLoading: true
        });
        var resendResult = await resendRegistration(userId);
        if (resendResult.success) {
            this.setState({
                ...this.state,
                successMessage: 'Registration Email resent successfully',
                isLoading: false
            });
        } else if (resendResult.error) {
            this.setState({
                successMessage: undefined,
                errorMessage: resendResult.error,
                isLoading: false
            });
        }
    }

    private needsPropertyAssociated(roleId: number) {
        var currentRole = this.props.currentUserAvailableRoles.find(role => {
            return role.id === roleId;
            console.log("Property Role ID: ", role.id );
        });
        if (currentRole && currentRole.name.includes('Property')) {
            return true;
        }
        return false;
    }

    private needsPropertyAdminAssociated(roleId: number) {
        var currentRole = this.props.currentUserAvailableRoles.find(role => {
            return role.id === roleId;
            console.log("Property Role ID: ", role.id );
        });
        if (currentRole && currentRole.name.includes('Property Admin')) {
            return true;
        }
        return false;
    }

    private needsCompanyAssociated(roleId: number) {
        var currentRole = this.props.currentUserAvailableRoles.find(role => {
            return role.id === roleId;
            console.log("Company Role ID: ", role.id );
        });
        if (currentRole && currentRole.name.includes('Company')) {
            return true;
        }
        return false;
    }

    private needsSystemAssociated(roleId: number) {
        var currentRole = this.props.currentUserAvailableRoles.find(role => {
            return role.id === roleId;
            console.log("System Role ID: ", role.id );
        });
        if (currentRole && currentRole.name.includes('System')) {
            return true;
        }
        return false;
    }

    private updateContextAvailableRoles() {
        let isSysAdmin = this.state.roleId === Roles.SystemAdminId;
        let isCustomerSupportRep = this.state.roleId === Roles.CustomerSupportRepresentativeId;

        // takes into consideration both current user and current company
        let contextAvailableRoles = this.props.currentUserAvailableRoles
            .map(role => ({
                value: role.id.toString(),
                label: role.name
            }))
            .filter(
                // filter out Customer Service Representative option for new users (only added through API endpoint)
                role =>
                    (role.value !== Roles.CustomerSupportRepresentativeId &&
                        ((isSysAdmin && role.value === Roles.SystemAdminId) ||
                            (!isCustomerSupportRep &&
                                !isSysAdmin &&
                                role.value !== Roles.SystemAdminId))) ||
                    (isCustomerSupportRep && role.value === Roles.CustomerSupportRepresentativeId)
            );

        this.setState(prevState => ({
            contextAvailableRoles: contextAvailableRoles,
            roleId:
                contextAvailableRoles.length === 1
                    ? contextAvailableRoles[0].value
                    : prevState.roleId
        }));
    }
}

export default withRouter<Props>(EditUserPane);



// WEBPACK FOOTER //
// ./src/components/pages/admin/EditUserPane.tsx